import { JobTeaserCard } from '@/components/job-teaser';
import { withNWTracking } from '@/components/nwt-tracking';
import { JobCard } from '@/domain/job-details/components/job-card/job-card';
import { TrackNwtEventProps } from '@/helpers/nwt-tracking';

type Props = {
  template: 'JobCard' | 'JobTeaserCard';
};

type JobCardProps = Parameters<typeof JobCard>[0] & {
  nwtTrackingOptions: Pick<TrackNwtEventProps, 'page' | 'event_schema' | 'tracking_token' | 'position'>;
};

export const useJobWithNWTracking = ({ template = 'JobTeaserCard' }: Props) =>
  template === 'JobCard' ? withNWTracking<JobCardProps>(JobCard) : withNWTracking(JobTeaserCard);
